import { Image } from '@components/gassan-ui'
import { FC, useState } from 'react'
import { RolexContainer } from '@components/_rolex/Container'
import { cn } from '@lib/cn'
import { getKontentImage, Item } from '@lib/kontent'
import Accordion from '../Accordion'
import { RolexRcpoModelPageV7 } from '@lib/kontent/models/RolexRcpoModelPageV7'

type ProductCertificationProps = {
  item: Item<RolexRcpoModelPageV7>
}

export const ProductCertification: FC<ProductCertificationProps> = ({ item }) => {
  const [openAccordionIndex, setOpenAccordionIndex] = useState<number | null>(0)
  const accordionItems = [
    {
      title: item.elements.certification_guarantee_title.value,
      content: item.elements.certification_guarantee_description.value,
    },
    {
      title: item.elements.certification_excellence_title.value,
      content: item.elements.certification_excellence_description.value,
    },
    {
      title: item.elements.certification_presentation_title.value,
      content: item.elements.certification_presentation_description.value,
    },
  ]

  const handleAccordionOpenChange = (index: number, open: boolean) => {
    setOpenAccordionIndex(open ? index : null)
  }

  return (
    <RolexContainer
      className={cn('flex flex-col-reverse', 'lg:grid lg:grid-cols-12 lg:items-center')}
    >
      <div className="lg:col-span-6">
        <Image
          className="aspect-[3/2]"
          placeholder={getKontentImage(item.elements.certification_mobile_image.value[0].url, {
            width: 50,
          })}
          sources={[
            getKontentImage(item.elements.certification_mobile_image.value[0].url, {
              width: 600,
            }),
            getKontentImage(item.elements.certification_desktop_image.value[0].url, {
              width: 2000,
            }),
            getKontentImage(item.elements.certification_desktop_image.value[0].url, {
              width: 2000,
            }),
          ]}
          alt={item.elements.certification_mobile_image.value[0].description}
        />
      </div>
      <div className={cn('mb-10', 'lg:col-span-5 lg:col-start-8 lg:mb-0')}>
        {accordionItems.map((item, index) => (
          <Accordion
            key={index}
            label={item.title}
            isLast={index === accordionItems.length - 1}
            open={openAccordionIndex === index}
            onOpenChange={(open) => handleAccordionOpenChange(index, open)}
          >
            {item.content}
          </Accordion>
        ))}
      </div>
    </RolexContainer>
  )
}
